import { theme } from '@Guidelines/Theme/theme';
import TransferCardShell from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewUpload/TransferCard/TransferCardShell';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Spinner } from '@verclam/ui-kit';

const SPINNER_PT = { root: { style: { width: '1rem', height: '1rem' } } };

const waitingStyle = css`
	display: flex;
	align-items: center;
	gap: 0.625rem;
	font-family: ${theme.fonts.mono};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkFaint};
`;

/** The queue item is confirmed; the page waits for the server to say what comes next. */
const AwaitingServerCard: React.FC = () => {
	return (
		<TransferCardShell
			title="Enregistrement reçu — préparation du traitement"
			detail="Le serveur a bien reçu l'enregistrement. Cette page se mettra à jour dès que la suite sera connue."
			footnote={null}
		>
			<div css={waitingStyle}>
				<Spinner aria-label="Préparation du traitement" pt={SPINNER_PT} />
				<span>Préparation en cours…</span>
			</div>
		</TransferCardShell>
	);
};

export default AwaitingServerCard;
